<template>
  <div>
    <the-nav-bar :title="$t('newSettings.kyc.title')" ref="nav" />
      <!-- load success -->
    <div class="success-wrapper">
      <!-- 正在审核 -->
      <div class="status-wrapper col-center" v-if="status === 'applied'">
        <img src="@/images/status-waiting.svg" alt="Wait" class="icon" />
        <span class="text">
          {{ $t('newSettings.apply.wait') }}
        </span>
        <span class="subtext">
          {{ $t('newSettings.apply.waitInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 审核成功 -->
      <div class="status-wrapper col-center" v-else-if="status === 'adopted'">
        <img src="@/images/status-success.svg" alt="Success" class="icon" />
        <span class="text">
          {{ $t('newSettings.apply.adopted') }}
        </span>
        <span class="subtext">
           {{ $t('newSettings.apply.adoptedInfo') }}
        </span>
        <md-button type="primary" @click="goBack">
          <span>{{ $t('common.back') }}</span>
        </md-button>
      </div>
      <!-- 未通过 -->
      <div class="status-wrapper col-center" v-else-if="status === 'fail'">
        <img src="@/images/status-failed.svg" alt="Failed" class="icon" />
                <span class="text">
          {{ $t('newSettings.apply.fail') }}
        </span>
        <span class="subtext">
        {{ $t('newSettings.apply.failInfo') }}  {{ message }}
        </span>
        <md-button type="primary" @click="goKyc">
          <span>{{ $t('common.reapply') }}</span>
        </md-button>
      </div>

    </div>

    <md-popup  class="inner-popup" v-model="isPopupShow" :mask-closable="true" >
      <md-popup-title-bar
        only-close
        :title="$t('newSettings.kyc.title')"
        title-align="left"
        @cancel="hidePopUp()"
      ></md-popup-title-bar>
    <md-field :brief="$t('newSettings.notKeepInfo')" class="body-wrapper">
     <template >
        <md-input-item
          name="trueName"
          type="text"
          v-model.trim="trueName"
          @blur="onValidate"
          :title="$t('newSettings.trueName')"
          align="right"
          :error="trueNameErr"
          :placeholder="$t('newSettings.tips.trueNamePlaceholder')"
        ></md-input-item>
        <md-input-item
          name="idcardNumber"
          type="text"
          v-model.trim="idcardNumber"
          @change="onValidate"
          :title="$t('newSettings.idcardNumber')"
          align="right"
          :error="idNumberErr"
          :placeholder="$t('newSettings.tips.idNumberPlaceholder')"
        ></md-input-item>

        <md-field-item :title="$t('newSettings.idcardFront')" class="upload">
          <div class="upload-content row-center">
            <md-image-reader
              name="idcardFront"
              :size="size"
              @select="onReaderSelect"
              @complete="onReaderComplete"
              @error="onReaderError"
            ></md-image-reader>
             
            <img class="preview-img" v-if="idcardFront" :src="idcardFront" />
            <div class="col-center" v-else>
              <svg class="icon"><use xlink:href="#icon-id-front" /></svg>
              <span class="text">{{ $t('newSettings.upload') }}</span>
            </div>
          </div>
         </md-field-item>

           <md-field-item :title="$t('newSettings.idcardBack')" class="upload">
          <div class="upload-content row-center">
            <md-image-reader
              name="idcardBack"
              :size="size"
              @select="onReaderSelect"
              @complete="onReaderComplete"
              @error="onReaderError"
            ></md-image-reader>
             
            <img class="preview-img" v-if="idcardBack" :src="idcardBack" />
            <div class="col-center" v-else>
              <svg class="icon"><use xlink:href="#icon-id-back" /></svg>
              <span class="text">{{ $t('newSettings.upload') }}</span>
            </div>
          </div>
         </md-field-item>
         
         <md-field-item :title="$t('newSettings.idcardWith')" class="upload">
          <div class="upload-content row-center">
            <md-image-reader
              name="idcardWith"
              :size="size"
              @select="onReaderSelect"
              @complete="onReaderComplete"
              @error="onReaderError"
            ></md-image-reader>
             
            <img class="preview-img" v-if="idcardWith" :src="idcardWith" />
            <div class="col-center" v-else>
              <svg class="icon"><use xlink:href="#icon-id-kyc" /></svg>
              <span class="text">{{ $t('newSettings.upload') }}</span>
            </div>
          </div>
         </md-field-item>
      </template>

      <div class="field-footer" slot="footer">
        <div class="info">
          {{ $t('newSettings.kyc.uploadTips') }}
        </div>
        <div class="btn-wrapper">
          <md-button
            :type="btnDisabled ? 'disabled' : 'primary'"
            @click="onSubmit"
          >
            <md-activity-indicator
              v-if="isSubmitting"
              type="carousel"
              color="currentColor"
            ></md-activity-indicator>
            <span v-else>{{ $t('common.submit') }}</span>
          </md-button>
        </div>
      </div>
    </md-field>
    </md-popup>


  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Popup,
  PopupTitleBar,
  Field,
  FieldItem,
  InputItem,
  Button,
  ImageReader,
  Toast,
  ActivityIndicator,
  Dialog,
} from 'mand-mobile';
import imageProcessor from 'mand-mobile/components/image-reader/image-processor';
import postUserKyc from '@/api/post-user-kyc';
import getUserKyc from '@/api/get-user-kyc';
export default {
  components: {
    TheNavBar,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [Field.name]: Field,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [ImageReader.name]: ImageReader,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      isPopupShow: false,
      trueName: '',
      idcardNumber: '',
      idcardFront: '',
      idcardBack: '',
      idcardWith: '',
      size: 8192,
      status: '',
      isSubmitting: false,
      isRemoving: false,
      btnDisabled: false,
      trueNameErr: '',
      idNumberErr: '',
      validate: false,
    };
  },
  computed: {

  },
  created(){
    getUserKyc().then(data => 
    {
      const d = data.data;
      this.trueName = d.trueName;
      this.status = d.status;
      this.message = d.message;
      if(this.status ==='no'){
        this.isPopupShow = true;
      }else{
        this.$store.commit('setKycInfo',{
          status:this.status,
          message: this.message,
        });
      }
    }).catch(err => {
      Dialog.alert({
        icon: 'fail',
        title: this.$t('error.occurs'),
        content: err.message,
        confirmText: this.$t('common.confirm'),
      });
      this.$router.go(-1);
    });
  },
  mounted() {
    
  },
  methods: {
    hidePopUp() {
      this.goBack();
    },
    goKyc() {
      this.isPopupShow =true;
    },
    goBack() {
      this.$refs.nav && this.$refs.nav.goBack();
    },
    onReaderSelect() {
      Toast.loading('loading...');
    },
    onReaderComplete(name, { dataUrl }) {
      imageProcessor({ dataUrl, width: 768, quality: 1 })
        .then(({ dataUrl }) => {
          Toast.hide();
          if (dataUrl) {
            this[name] = dataUrl;
          }
        })
        .catch(err => {
          Toast.failed(err.message);
        });
    },
    onReaderError(name, {msg}) {
      Toast.failed(msg);
    },
    onSubmit() {
      if(this.trueName.length <1){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kyc.trueNameErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      }
      if(this.idcardNumber.length <1){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kyc.idcardNumberErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      }
      if(this.idcardFront.length <1){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kyc.idcardFrontErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      } 
      if(this.idcardBack.length <1){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kyc.idcardBackErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      } 
      if(this.idcardWith.length <1){
        Dialog.alert({
          icon: 'fail',
          title: this.$t('error.occurs'),
          content: this.$t('newSettings.kyc.idcardWithErr'),
          confirmText: this.$t('common.confirm'),
        });
        return; 
      } 
      this.isSubmitting = true;
      let params = {
        trueName: this.trueName,
        idcardNumber: this.idcardNumber,
        idcardFront: this.idcardFront,
        idcardBack: this.idcardBack,
        idcardWith: this.idcardWith,
      };

      postUserKyc(params)
        .then(data => {
          this.isSubmitting = false;
          const d = data.data;
          this.trueName = d.trueName;
          this.status = d.status;
          this.message = d.message;
          if(this.status ==='no'){
            this.isPopupShow = true;
          }else{
            this.$store.commit('setKycInfo',{
              status:this.status,
              message: this.message,
            });
            this.isPopupShow =false;
          }
          
        })
        .catch(err => {
          this.isSubmitting = false;
          Dialog.alert({
            icon: 'fail',
            title: this.$t('error.occurs'),
            content: err.message,
            confirmText: this.$t('common.confirm'),
          });
        });
    },
    onValidate(name, value) {
      this.trueNameErr = '';
      this.idNumberErr = '';
      this.validate = false;
      switch (name) {
        case 'trueName':
          if (value !==''&&!/\S+/.test(value)) {
            this.trueNameErr = this.$t('newSettings.incorrect', {
              name: this.$t('newSettings.trueName'),
            });
          }
          break;
        case 'idcardNumber':
          if (value !=='' &&
            value.length<5
          ) {
            this.idNumberErr = this.$t('newSettings.incorrect', {
              name: this.$t('newSettings.idcardNumber'),
            });
          }
          break;
        default:
          this.validate = true;
      }
    },
    copy(source, target) {
      Object.entries(source).forEach(([key]) => {
        source[key] = target[key];
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .md-popup
    top: 10vh;
.status-wrapper {
  min-height: 80vw;

  .md-icon, .icon {
    font-size: 16vw;
    width: 16vw;
    height: 16vw;
  }

  .text {
    margin-top: 9.6vw;
    font-size: 4.8vw;
  }

  .subtext {
    margin: 2.13vw 9.6vw 0;
    text-align: center;
  }

  .md-button {
    margin-top: 14.4vw;
    width: 60vw;
  }

}

.body-wrapper {
  padding-bottom: 20vw;

  .md-field-item {
    margin-bottom: 3.2vw;
  }

  & >>> {
    .md-field-item-content {
      height: 17.07vw;

      &:before {
        content: none;
      }
    }

    .md-field-item-title {
      width: 32vw;
      font-size: 3.73vw;
      font-weight: bold;
    }

    .md-field-item-control {
      width: 53.6vw;
      text-align: right;
    }

    .md-input-item-input {
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      padding: 0 2.67vw;
      background: #f8fbfc;
    }

    .md-field-item-children {
      position: absolute;
      right: 0;
      top: 100%;
      z-index: 10;
      margin-top: 0;
    }
  }

  .upload {
    & >>> {
      .md-field-item-content {
        height: auto;
        align-items: flex-start;
      }

      .md-field-item-title {
        margin-top: 5.33vw;
        width: 40vw;
      }

      .md-field-item-control {
        width: 40vw;
        flex: 0 0 auto;
      }
    }

    .upload-content {
      position: relative;
      box-sizing: border-box;
      margin-top: 2.67vw;
      border: 0.27vw solid #eaf1f3;
      border-radius: 2.67vw;
      height: 40vw;
      background: #f8fbfc;
      color: #BCC7CB;
      overflow: hidden;

      .preview-img {
        width: 100%;
        line-height: 40vw;
        vertical-align: middle;
      }

      .icon {
        width: 31.38vw;
        height: 31.38vw;
      }
    }
  }

  .info {
    margin-top: 4.8vw;
    color: #84969c;
  }

  .btn-wrapper {
    margin-top: 9.6vw;

    .md-button {
      margin-bottom: 4.8vw;
    }

    & >>> .md-activity-indicator-svg {
      width: 16vw !important;
      height: 4vw !important;
    }
  }
}



</style>
